import { call, put, takeLatest } from "redux-saga/effects";
import {
  RATE_LIST_REPORT_GO_BUTTON_ACTION,
} from "./actionType";

import {
  Rate_List_Report_GoButton_Success,
  Rate_List_Report_ApiErrorAction,
} from "./action";

import { Rate_List_Report_API } from "../../../helpers/backend_helper";

function* Rate_List_Report_GenFunc({ config }) {
  try {
    // 🔹 Call API
    let response = yield call(Rate_List_Report_API, config);

    // 🔹 Safely handle missing or invalid data
    const data = Array.isArray(response.Data) ? response.Data : [];

    // 🔹 Format numbers (like Rate) to 2 decimal places
    const formattedData = data.map((item) => {
      const formattedItem = { ...item };
      for (const key in formattedItem) {
        // Format only number fields
        if (!isNaN(formattedItem[key]) && formattedItem[key] !== null && formattedItem[key] !== "") {
          formattedItem[key] = Number(formattedItem[key]).toFixed(2);
        }
      }
      return formattedItem;
    });

    // 🔹 Attach formatted data and btnId
    response["Data"] = formattedData;
    response["Type"] = config.btnId;

    // 🔹 Dispatch success
    yield put(Rate_List_Report_GoButton_Success(response));

  } catch (error) {
    console.error("❌ Rate List Report Saga Error:", error);
    yield put(Rate_List_Report_ApiErrorAction());
  }
}

export default function* Rate_List_Report_Saga() {
  yield takeLatest(RATE_LIST_REPORT_GO_BUTTON_ACTION, Rate_List_Report_GenFunc);
}
